
import { createContext } from 'react';
import counterStore from './count';
import storeData from './data';
 
export const storesContext = createContext({
  counterStore,
  storeData
})
